/*
 * @Author: libo 
 * @Date: 2020-11-13 17:44:09 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-06-06 14:29:03
 */
<template>
  <a-modal
    :title="title"
    :width="width"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <div class="table-operator" style="display:flex;justify-content:flex-end;">
      <a-button type="primary" icon="download" @click="handleExportXls($t('日报表详情'))">{{ $t('导出') }}</a-button>
    </div>
    <a-spin :spinning="confirmLoading">
      <div class="form-contain">
        <a-table 
          :columns="columns"
          tableLayout="fixed"
          :scroll="{ x: 1700,y: 500 }"
          :data-source="list"
          rowKey='id'
          :pagination="ipagination"
          @change="handleTableChange"
          class="j-table-force-nowrap"
        >
        </a-table>
      </div> 
    </a-spin>
  </a-modal>
</template>

<script>
  import { downFile, getAction,putAction } from '@/api/manage'
  import {isUndefined,isNull,isUndefinedAndNull} from'@/utils/validate'
  import {payWayObj,payTypeObj} from '@/utils/constants/commonConstant'

  export default {
    name: 'MeterDailyStatementModal',
    components: {
      // DetailList,
      // DetailListItem,
    },
    data () {
      return {
        list: [],
        title: this.$t('操作'),
        visible: false,
        width: 1000,
        disableSubmit:false,
        model: {},
        queryParam:{},
        filters: {},
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          doPayTask: "/jeecg-charge/meter/userPay/doPayTask",
          UserRecordList: "/jeecg-charge/meter/meterUserPayRecord/dayReportList", //详情查询接口
          exportXlsUrl: "jeecg-charge/meter/meterUserWaterReportDay/exportXlsForDayUseDetailList", //导出接口
        }
      }
    },
    created () {
    },
    computed: {
      // i18n：列定义使用 computed 以响应语言切换
      columns() {
        return [
          {
            title:this.$t('日期'),
            align:"center",
            dataIndex: 'createTime',
            width:180,
            ellipsis: true,
            customRender:(t,r,index) => {
              // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
              if(!isNull(r.updateTime)&&r.updateTime!="") {
                return r.updateTime
              }
              return t
            }
          },{
            title:this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId',
            width:150,
            ellipsis: true
          },{
            title:this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title:this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },/*{
            title:'用户电话',
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true
          },*/{
            title:this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            ellipsis: true
          },{
            title:this.$t('缴费途径'),
            align:"center",
            dataIndex: 'payWay',
            customRender:(t,r,index) => {
              if(isUndefined(payWayObj[t])) {
                return this.$t("其他")
              }
              return this.$t(payWayObj[t])
            },
            width:120,
            ellipsis: true
          },{
            title:this.$t('购买量(吨)'),
            align:"center",
            dataIndex: 'payWaterNum',
            width:150,
            ellipsis: true,
            customRender:(t,r,index) => {
              if(isUndefinedAndNull(t)) {
                return '--'
              }
              if(!isUndefined(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
                return '-'+t
              }
              return t
            }
          },{
            title:this.$t('购买金额(元)'),
            align:"center",
            dataIndex: 'userPayAccountNum',
            width:150,
            ellipsis: true,
            customRender:(t,r,index) => {
              if(!isUndefined(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
                return '-'+t
              }
              return t
            }
          },/*{
            title:'价格名称',
            align:"center",
            dataIndex: 'userPriceName',
            width:100,
            ellipsis: true
          },{
            title:'水价合计(元)',
            align:"center",
            dataIndex: 'userPriceTotal',
            width:150,
            ellipsis: true
          },*/{
            title:this.$t('剩余金额(元)'),
            align:"center",
            dataIndex: 'userNowAccountNum',
            width:150,
            ellipsis: true
          },{
            title:this.$t('操作员'),
            align:"center",
            dataIndex: 'createBy',
            width:150,
            ellipsis: true,
            customRender:(t,r,index) => {
              // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
              if(!isNull(r.updateBy)&&r.updateBy!="") {
                return r.updateBy
              }
              return t
            }
          },
          {
            title:this.$t('操作类型'),
            align:"center",
            fixed:"right",
            dataIndex: 'userAccountPayType',
            customRender:(t,r,index) => {
              if(isUndefined(payTypeObj[t])) {
                return this.$t("其他")
              }
              return this.$t(payTypeObj[t])
            },
            width:100,
            ellipsis: true
          }
        ]
      },
    },
    methods: {
      handleExportXls(fileName){
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        let param = {...this.queryParam};
        param.createBy = this.model.createBy
        param.reportDate = this.model.reportDate
        param.userAccountPayType = this.model.userAccountPayType
        param.waterTypeId = this.model.waterTypeId
        param.reportDate = this.queryParam.reportMonthDay;
        if(this.selectedRowKeys && this.selectedRowKeys.length>0){
          param['selections'] = this.selectedRowKeys.join(",")
        }
        console.log("导出参数",param)
        downFile(this.url.exportXlsUrl,param).then((data)=>{
          if (!data) {
            this.$message.warning(this.$t("文件下载失败"))
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },
      handleOk(e) {
        console.log(e);
        this.visible = false;
      },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.queryUserRecordList();
      },
      queryUserRecordList() {  //详情
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.createBy = this.model.createBy
        params.reportDate = this.model.reportDate
        params.userAccountPayType = this.model.userAccountPayType
        params.waterTypeId = this.model.waterTypeId
        params.reportDate = this.queryParam.reportMonthDay;
        getAction(this.url.UserRecordList, params).then((res) => {
          if(res.success){
            this.list = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      edit (queryParam,record) {
        this.queryParam = Object.assign({}, record);
        this.model = Object.assign({}, queryParam);
        this.visible = true;
        console.log(this.model);
        console.log(this.queryParam);
        this.$nextTick(() => {
        // this.form.setFieldsValue(pick(this.model,))
        })
        this.queryUserRecordList();
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
.option{
  min-height: 400px;
}
.form-contain{
    height: auto;
    overflow-x: hidden;
}
</style>